import { Quill } from 'vue2-editor';

let Parchment = Quill.import('parchment');
Parchment.tagName = 'ql-tag';

let config = { scope: Parchment.Scope.INLINE };
let TrainerTagModule = new Parchment.Attributor.Class('tag', 'ql-tag', config);

let Inline = Quill.import('blots/inline');
class ActiveTrainerTag extends Inline {}

/* Set `a` as tag with `href` attribute as a workaround
 * to stop the highlight formatting to the following words
 * https://github.com/quilljs/quill/issues/1232
 */
class HighlightTrainerTag extends Inline {
  static create() {
    let node = super.create();
    node.setAttribute('href', '#');
    node.setAttribute('class', 'highlight');
    return node;
  }

  static formats(node) {
    return node.getAttribute('href');
  }
}

class PhraseNonEditable extends Inline {
  static create() {
    let node = super.create();
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('class', 'non-editable');
    return node;
  }

  static formats(node) {
    return node.getAttribute('contenteditable');
  }
}

class Scroll extends Quill.import('blots/scroll') {
  constructor(domNode, config) {
    super(domNode, config);

    this.emitter = config.emitter;

    if (Array.isArray(config.whitelist)) {
      this.whitelist = config.whitelist.reduce((whitelist, format) => {
        whitelist[format] = true;
        return whitelist;
      }, {});
    }

    this.mutationObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Handle DOM node insertion here
        }
      }
    });

    this.mutationObserver.observe(domNode, {
      childList: true,
      subtree: true,
    });

    this.optimize();
    this.enable();
    return this;
  }
}

Quill.imports['blots/scroll'] = undefined;
Quill.register({ 'blots/scroll': Scroll });

ActiveTrainerTag.blotName = 'active-tag';
ActiveTrainerTag.tagName = 'ql-active-tag';
HighlightTrainerTag.blotName = 'highlight-tag';
HighlightTrainerTag.tagName = 'a';
PhraseNonEditable.blotName = 'phrase-noneditable';
PhraseNonEditable.tagName = 'ql-noneditable';

// customize to add trainer-tag on higher order
Inline.order = [
  'cursor',
  'inline',
  'link',
  'underline',
  'strike',
  'italic',
  'bold',
  'highlight-tag',
  'active-tag',
  'phrase-noneditable',
  'script',
  'code'
];

Quill.register(TrainerTagModule, true);
Quill.register(ActiveTrainerTag, true);
Quill.register(HighlightTrainerTag, true);
Quill.register(PhraseNonEditable, true);

export { TrainerTagModule, ActiveTrainerTag, HighlightTrainerTag, PhraseNonEditable };
